module.exports = __webpack_public_path__ + "img/icon_geod.42ef3061.png";